// Options for the Language filter. The value is what the report API expects (see
// sof2_portal_backend reportValidators.validateLanguage).
export const LANGUAGE_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'en-US', label: 'English' },
  { value: 'fr-CA', label: 'French' }
];

export default LANGUAGE_FILTER_OPTIONS;
